import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { useFormikContext } from "formik";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { IStep } from "../types";

interface Props {
  step: IStep;
  isActive: boolean;
  onClick: VoidFunction;
}

export const StepTab: FC<Props> = ({ step, isActive, onClick }) => {
  const { t } = useTranslation();

  const { stepTitle, responsibleFields } = step;

  const { errors, touched } = useFormikContext();

  const isShownError = responsibleFields.some(
    (fieldName) => errors[fieldName] && touched[fieldName]
  );

  const isErrorOnActiveStep = isShownError && isActive;

  const title =
    typeof stepTitle === "string"
      ? stepTitle
      : t(stepTitle.i18nKey, stepTitle.i18nParams);

  const combinedClassNames = cn(
    "relative flex-1 py-3.5 text-sm xl:text-base !border-purple-base font-semibold",
    {
      "!bg-red-light !text-white-base": isErrorOnActiveStep,
      "!border-red-light text-red-light outline outline-1 hover:bg-red-light/20":
        isShownError,
    }
  );

  return (
    <Button
      className={combinedClassNames}
      variant={isActive ? ButtonVariants.PRIMARY : ButtonVariants.SECONDARY}
      type="button"
      onClick={onClick}
    >
      {title}

      {isShownError && (
        <span className="absolute top-2 right-2 w-2 h-2 bg-red-light rounded-full" />
      )}
    </Button>
  );
};
